export function findGoBackCount(history: string[]): number | undefined {
  const withoutFragment = (url: string): string => url.split('#')[0];
  const currentUrl: string | undefined = history.length > 0 ? withoutFragment(history[history.length - 1]) : undefined;
  for (let i: number = history.length - 2; i >= 0; i--) {
    if (withoutFragment(history[i]) !== currentUrl) {
      return history.length - 1 - i;
    }
  }
  return undefined;
}
